import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Home scrolls to this section after its promotion content has loaded.
    if (pathname === "/" && hash === "#promotion-section") return;

    const scrollDuration = 600; // milliseconds
    const start = window.scrollY;
    const startTime = performance.now();
    let animationFrame;

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / scrollDuration, 1); // [0,1]

      const easeOutQuad = (t) => t * (2 - t); // easing function

      window.scrollTo(0, start * (1 - easeOutQuad(progress)));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animateScroll);
      }
    };

    animationFrame = requestAnimationFrame(animateScroll);
    return () => cancelAnimationFrame(animationFrame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
